/**
 * Series Domain Enums
 *
 * Shared enums used across client, admin, and edge apps.
 * Define the domain language for Series packaging and distribution.
 */

/**
 * Visibility of a series in the platform
 */
export enum SeriesVisibility {
	Public = "public",
	Unlisted = "unlisted",
	Private = "private",
}

/**
 * Access policy for gating series availability
 */
export enum SeriesAccessPolicy {
	Free = "free",
	Premium = "premium",
	League = "league",
	Invite = "invite",
}

/**
 * Status of a dash within a specific series
 */
export enum DashSeriesStatus {
	Active = "active",
	Hidden = "hidden",
}
